import { PolygraphyProductUrlType } from '../../../../../../../services/exports/Constants';

export default {
  form: {
    url_type: {
      options: {
        [PolygraphyProductUrlType.OnlineShop]: 'Boutique en ligne',
        [PolygraphyProductUrlType.Storefront]: 'Vitrine',
        [PolygraphyProductUrlType.Custom]: 'Personnalisé',
      },
    },
  },
  labels: {
    save_changes_to_see_preview: "Enregistrez pour voir l'aperçu",
  },
  buttons: {
    save_and_preview: 'Enregistrer et apercevoir',
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement du produit',
    failed_to_save_changes: "Échec de l'enregistrement !",
    changes_got_saved: 'Modifications enregistrées !',
  },
};
